import DomainException from '~/modules/Exceptions/Domain/DomainException'

export class FileUrlDomainException extends DomainException {
  public static cannotExtractExtensionId = 'file_url_cannot_extract_extension_id'
  public static cannotExtractFilenameId = 'file_url_cannot_extract_filename_id'
  public static invalidFileUrlId = 'file_url_invalid_file_url'

  public static invalidFileUrl (url: string): FileUrlDomainException {
    return new FileUrlDomainException(
      `Url ${url} is not valid`,
      this.invalidFileUrlId
    )
  }

  public static cannotExtractFilename (url: string): FileUrlDomainException {
    return new FileUrlDomainException(
      `Cannot get filename from url ${url}`,
      this.cannotExtractFilenameId
    )
  }

  public static cannotExtractExtension (url: string): FileUrlDomainException {
    return new FileUrlDomainException(
      `Cannot get extension from url ${url}`,
      this.cannotExtractExtensionId
    )
  }
}
